var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78571 1L8.58066 3.00215C7.8273 2.57761 6.94421 2.33333 6 2.33333C3.23858 2.33333 1 4.42267 1 7C1 7.41487 1.058 7.8171 1.16686 8.2M4.21429 13L3.41931 10.9978C4.17268 11.4224 5.05578 11.6667 6 11.6667C8.76142 11.6667 11 9.57733 11 7C11 6.58513 10.942 6.1829 10.8331 5.8",
    stroke: "#0072b3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.93d0f9e32aee9e586cb6f23cb55d76a3.svg";
export { ForwardRef as ReactComponent };